import { configureStore } from '@reduxjs/toolkit'
import alert from './slices/alert';

const store = configureStore({
  reducer: {
    alert: alert,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
});

export default store;
